<template>
    <div>
        <h1 class="subtitle">Inventario</h1>
        <div class="nj-cols">
            <div class="nj-card">
                <div class="nj-gridx">
                    <div>
                        <div class="nj-label">Producto</div>
                        <input type="text"
                               class="nj-text"
                               v-model="filters.prv_nombre"
                               placeholder="categoria, tipo, marca, id, nombre, unidad">
                    </div>
                    <div>
                        <div class="nj-label">Estado (a nivel de producto)</div>
                        <select class="nj-select"
                                v-model="filters.prv_estado">
                            <option v-for="item in estados"
                                    :key="item.est_id"
                                    :value="item.est_id">{{ item.est_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Almacen</div>
                        <!-- ! cambiar este select por el InputSelect -->
                        <select class="nj-select"
                                v-model="filters.alm_id">
                            <option v-for="item in almacenes"
                                    :key="item.alm_id"
                                    :value="item.alm_id">{{ item.pry_nombre }} | {{ item.alm_nombre }}</option>
                        </select>
                    </div>
                </div>
                <Buttons line>
                    <Button label="Buscar"
                            icon="search"
                            @click="buscar()"></Button>
                </Buttons>
                <br>
                <b-table :data="productos"
                         @page-change="changePage($event)"
                         :total="filters.page.total"
                         :per-page="filters.page.size"
                         :current-page="filters.page.number"
                         :paginated="true"
                         :backend-pagination="true"
                         pagination-order="is-centered">
                    <template slot-scope="props">
                        <b-table-column label="ID"
                                        header-class="is-info">{{ props.row.pal_id }}</b-table-column>
                        <b-table-column label="Almacén"
                                        header-class="is-info">{{ props.row.alm_nombre }}</b-table-column>
                        <b-table-column label="Categoria"
                                        header-class="is-info">{{ props.row.cat_nombre }}</b-table-column>
                        <b-table-column label="Tipo"
                                        header-class="is-info">{{ props.row.tip_nombre }}</b-table-column>
                        <b-table-column label="Producto"
                                        header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                        <b-table-column label="Unidad"
                                        header-class="is-info">{{ props.row.unm_simbolo }}</b-table-column>
                        <b-table-column label="Marca"
                                        header-class="is-info">{{ props.row.mar_nombre }}</b-table-column>
                        <b-table-column label="Estado"
                                        header-class="is-info">
                            <b-field>
                                <b-tag :class="tagEstado(props.row)">{{ tagEstadoNombre(props.row) }}</b-tag>
                            </b-field>
                        </b-table-column>
                        <b-table-column label="Stock"
                                        header-class="is-info">{{ props.row.pal_stock }}</b-table-column>
                        <b-table-column label="Opciones"
                                        header-class="is-info">
                            <div class="nj-flx">
                                <button class="nj-button icon"
                                        @click="openHistorialAsignacionItems(props.row)"
                                        title="Historial asignaciones"><i class="mdi-file-document"></i></button>
                                <button class="nj-button icon"
                                        @click="openHistorialTransferenciaItems(props.row)"
                                        title="Historial transferencias"><i class="mdi-file-document-box"></i></button>
                                <button class="nj-button icon"
                                        @click="openKardex(props.row)"
                                        title="Kardex"><i class="mdi-playlist-check"></i></button>
                            </div>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
        <HistorialAsignaciones v-if="showHistorialAsignaciones"
                               :filters="filters2"
                               :titulo="titulo"
                               @close="cerrarPopups()">
        </HistorialAsignaciones>
        <HistorialTransferencias v-if="showHistorialTransferencias"
                                 :pal_id="pal_id"
                                 @close="cerrarPopups()">
        </HistorialTransferencias>
        <ProductoAlmacenKardex v-if="showKardex"
                               :pal_id="pal_id"
                               @close="cerrarPopups()"></ProductoAlmacenKardex>
    </div>
</template>
<script>
import Estado from "../../constants/estado"
import { ProductoAlmacenService, ResponseStatus, UsuarioService } from "../../services"
import { Data } from "../../util"
import Toast from "../../util/toast"
import { Button, Buttons } from "../components"
import HistorialAsignaciones from "./../asignacionItems/HistorialAsignaciones"
import HistorialTransferencias from "./../transferenciaItems/HistorialTransferencias"
import ProductoAlmacenKardex from "./ProductoAlmacenKardex.vue"

export default {
    name: "Inventario",
    components: {
        HistorialAsignaciones,
        HistorialTransferencias,
        ProductoAlmacenKardex,
        Button,
        Buttons,
    },
    data() {
        return {
            filters: {
                prv_nombre: null,
                prv_estado: null,
                alm_id: null,
                page: {
                    number: 1,
                    size: 10,
                    total: 0
                },
            },
            filters2: {
                pal_id: null,
            },
            estados: [],
            productos: [],
            almacenes: [],
            pal_id: null,
            showHistorialAsignaciones: false,
            showHistorialTransferencias: false,
            showKardex: false,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            const request = {
                producto_almacen: this.filters
            }
            ProductoAlmacenService
                .buscar(request).then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.filters.page = response.data
                        this.productos = this.filters.page.list
                    }
                    else {
                        Toast.error(response.message)
                    }
                }).catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        changePage(number) {
            this.filters.page.number = number
            this.buscar()
        },
        tagEstado(item) {
            if (item.pal_stock == 0) {
                return Estado.Tag(item.pal_stock_estado)
            } else {
                return Estado.Tag(item.prv_estado)
            }
        },
        tagEstadoNombre(item) {
            if (item.pal_stock == 0) {
                return item.pal_stock_estado_nombre
            } else {
                return item.pal_estado_nombre
            }
        },
        openHistorialAsignacionItems(item) {
            this.showHistorialAsignaciones = true
            this.titulo = "Historial de asignaciones por item"
            this.filters2.pal_id = item.pal_id
        },
        openHistorialTransferenciaItems(item) {
            this.pal_id = item.pal_id
            this.showHistorialTransferencias = true
        },
        openKardex(item) {
            this.pal_id = item.pal_id
            this.showKardex = true
        },
        cerrarPopups() {
            this.showHistorialAsignaciones = false
            this.showHistorialTransferencias = false
            this.showKardex = false
            this.pal_id = null
            this.filters2.pal_id = null
        },
    },
    mounted() {
        this.estados.push(Estado.ACTIVO, Estado.INACTIVO, Estado.SIN_STOCK)
        this.filters.prv_estado = 1
        this.filters.prv_nombre = ""
        // Cargando los almacenes
        if (UsuarioService.isCoorporative()) {
            this.almacenes = Data.get(Data.listNames.almacenes)
        }
        else {
            this.almacenes = Data.get(Data.listNames.almacenes).filter(item => item.pry_id == UsuarioService.getUsuario().pry_id)
        }
        this.buscar()
    }
}
</script>

<style scoped></style>